<div>
  @if(allColumns && allColumns.length > 0) {
    <app-mi-table
      [collectionOfColumns]="allColumns"
      [attributeLabels]="attributeLabels"
      [data]="tableData"
      entityName="protocol"
      [isLoading]="isLoading"
      (onPageChange)="onPageChange($event)"
      (itemPerPageChange)="itemPerPageChange($event)"
      [totalRecords]="totalRecords"
      [filterList]="filterList"
      (onValueChange)="onFilterValueChange($event)"
      (onSearchValueChange)="onSearchValueChanges($event)"
      (onSortData)="onSortData($event)"
      (onRowSelection)="onRowSelect($event)"
      [isEntity]="isEntity"
      [pagination]="pagination"
      [hideAddButton]="true"
      [hideActionButtons]="true">
    </app-mi-table>
  }
</div>